module.exports = __webpack_public_path__ + "img/load2.07e38b35.png";